import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { CommonPreferences } from '@sorare/core/src/components/settings/CommonPreferences';
import { Currency } from '@sorare/core/src/components/settings/Currency';
import { Disable3D } from '@sorare/core/src/components/settings/Disable3D';
import { PreferredLanguage } from '@sorare/core/src/components/settings/PreferredLanguage';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';

import { SettingsWrapper } from 'components/settings/SettingsWrapper';

export const GlobalPreferences = () => {
  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.GLOBAL_PREFERENCES]}>
      <Vertical gap={2}>
        <Currency />
        <PreferredLanguage />
        <Disable3D />
        <CommonPreferences />
      </Vertical>
    </SettingsWrapper>
  );
};

export default GlobalPreferences;
